import { commitMutation } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';
import { getEnvironment } from '../../../../shared/utils/helpers';

const BulkSendInvitationsToContractorsMutation = (input, callback) => {
  commitMutation(getEnvironment(), {
    mutation: graphql`
      mutation BulkSendInvitationsToContractorsMutation(
        $input: SendBulkInvitationsToContractorsInput!
      ) {
        sendBulkInvitationsToContractors(input: $input) {
          updatedContractors {
            id
          }
        }
      }
    `,
    variables: {
      input
    },
    onCompleted: (response, errors) => {
      callback(response.updatedContractors, errors);
    },
    onError: err => console.error(err)
  });
};

export default BulkSendInvitationsToContractorsMutation;
